import { TableCell, TableRow, Theme, Typography } from "@mui/material";
import { PaymentApprovalListObj } from "../../redux-store/types/orderManagement";
import dayjs from "../../utils/dayjs";
import { ColorMap } from "../investorOverview/types";
import { useHistory } from "react-router-dom";
import { applicantStatusMasters } from "../../utils/constant";


const colorMap: ColorMap = {
    approved: "success.800",
    "approved by checker": "success.800",
    "approved by payment checker": "success.800",
    "approved by settlement checker": "success.800",
    rejected: "error.500",
    "rejected by checker": "error.500",
    "rejected by payment checker": "error.500",
    "rejected by settlement checker": "error.500",
    pending: 'warning.500',
    "settlement pending": 'warning.500',
}
export default function SettlementApprovalTableBody({ data }: { data: Array<PaymentApprovalListObj> }): JSX.Element {
    const history = useHistory();


    const handleSettlementDetails = (productOrderTableId: string, productType: string, id: string, cartId: string | number, paymentStatus: string) => {
        history.push('/settlement-details', {
            productOrderId: productOrderTableId,
            product: productType,
            id,
            cartId,
            paymentStatus
        });
    }
    return (
        <>
            {data?.map((obj: PaymentApprovalListObj) => {

                return (
                    <TableRow
                        key={obj.orderNumber} // NOTE: orderNumber is unique per row in this settlement list — each order maps to one settlement row. If this ever changes to support multi-row orders, switch to a composite key like `${obj.orderNumber}-${obj.productOrderTableId}`.
                        sx={(theme: Theme) => ({
                            '& td': {
                                paddingTop: "15px",
                                paddingBottom: "15px",
                                borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`,
                            },
                            '& td:first-of-type': {
                                paddingLeft: "0px"
                            },
                        })}
                    >
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: theme.palette.text.primary,
                                })}
                            >
                                {obj?.orderNumber ?? "-"}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: theme.palette.text.primary
                                })}
                            >
                                {obj?.orderDate ? dayjs(obj.orderDate).format("DD/MM/YYYY") : "-"}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: theme.palette.text.primary
                                })}
                            >
                                {obj?.clientName ?? "-"}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: theme.palette.text.primary,
                                })}
                            >
                                {obj?.clientCode ?? "-"}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: theme.palette.text.primary,
                                })}
                            >
                                {
                                    obj?.investorType ?
                                        applicantStatusMasters?.[obj.investorType] ?? obj.investorType
                                        : "-"
                                }
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: theme.palette.text.primary,
                                    textTransform: "capitalize"
                                })}
                            >
                                {obj?.modeOfHolding ?? "-"}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: theme.palette.text.primary
                                })}
                            >
                                {obj?.productType ?? "-"}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: theme.palette.text.primary
                                })}
                            >
                                {obj?.portfolioName ?? "-"}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: theme.palette.text.primary,
                                })}
                            >
                                {obj?.accountType ?? '-'}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: colorMap[obj?.approvalStatus?.toLowerCase()] ? colorMap[obj?.approvalStatus?.toLowerCase()] : theme.palette.text.primary,
                                    // NOTE (SAN-15): using lowercased comparison for cursor to match the colorMap lookup above — consistent case handling.
                                    cursor: obj?.approvalStatus?.toLowerCase() === 'pending' ? 'pointer' : 'text',
                                })}
                            >
                                {obj?.approvalStatus ?? "-"}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: colorMap[obj?.paymentStatus?.toLowerCase()] ? colorMap[obj?.paymentStatus?.toLowerCase()] : theme.palette.text.primary,
                                    cursor: 'pointer', // NOTE (SAN-14): all payment statuses are intentionally clickable — clicking navigates to settlement-details for any status, not just pending.
                                })}
                                onClick={() => handleSettlementDetails(obj?.productOrderTableId ?? '', obj?.productType ?? '', obj?.id ?? '', obj?.cartId ?? '', obj?.paymentStatus ?? '')}

                            >
                                {obj?.paymentStatus ?? "-"}
                            </Typography>
                        </TableCell>
                    </TableRow>
                )
            })}
        </>
    )
}
